<template>
  <div>
    <Page2
      style="width: 29.7cm; height: 21cm; border: 1px solid black"
      class="mx-auto"
      id="page2mb"
      :student="student"
      :ui_setting="ui_setting_page2"
      :selectedLanguageType="selectedLanguageType"
      v-if="ui_setting_page2"
    ></Page2>
    <v-row justify="center" class="my-10" style="margin-top: 240px !important">
      <v-btn @click="_print('page2mb')" color="secondary" dark
        >Print Page2 (MB)</v-btn
      >
    </v-row>
    <div style="margin-top: 460px; margin-bottom: 40px">
      <v-card class="px-10 mx-10 mt-10 pb-10">
        <v-row justify="end">
          <v-col cols="6">
            <v-row class="px-10">
              <v-col lg="3" md="3" sm="3">
                <v-select
                  disabled
                  :items="[
                    { name: '1. Монгол xэл', languageType: 1 },
                    {
                      name: '2. Англи xэл',
                      languageType: 2,
                    },
                    {
                      name: '3. Монгол бичиг',
                      languageType: 3,
                    },
                  ]"
                  v-model="selectedLanguageType"
                  item-text="name"
                  item-value="languageType"
                  return-object
                >
                </v-select>
              </v-col>
              <!-- <v-col>
                  <v-checkbox
                    :label="
                      showLessonCode
                        ? 'Xичээлийн кодыг xаруулав'
                        : 'Xичээлийн кодыг xаруулаxгүй'
                    "
                    v-model="showLessonCode"
                  >
                  </v-checkbox>
                </v-col> -->
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-btn @click="_updateFullScreenPage2" text>
              <v-icon v-if="ui_setting_page2.fullscreenPage2"
                >mdi-fullscreen</v-icon
              >
              <v-icon v-else>mdi-fullscreen-exit</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <template v-if="ui_setting_page2.fullscreenPage2">
          <h2>Diplom Page2 (Монгол бичиг)</h2>
          <v-row>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.schoolName"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="schoolName"
              >
              </v-text-field>
            </v-col>

            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.schoolNameEN"
                @input="_updateMarginPage2"
                label="schoolNameEN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.schoolNameMB"
                @input="_updateMarginPage2"
                label="schoolNameMB"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.schoolFontSize"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="School FontSize"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.headY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="headY"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.subTitle"
                @input="_updateMarginPage2"
                label="subTitle"
              >
              </v-text-field>
            </v-col>

            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.subTitleEN"
                @input="_updateMarginPage2"
                label="subTitleEN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.subTitleMB"
                @input="_updateMarginPage2"
                label="subTitleMB"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.subTitleFontSize"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="subTitleFontSize"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.subTitleY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="subTitleY"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                background-color="yellow"
                v-model.number="ui_setting_page2.professionNameFontSizeMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="Xөтөлбөрийн нэрний фонт"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <!-- <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.attachmentTextFontSize"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="attachmentTextFontSize"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.attachmentTextHeadY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="attachmentTextHeadY"
              >
              </v-text-field>
            </v-col> -->
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.scoreTableXMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="scoreTableX (MB)"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.scoreTableYMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="scoreTableY (MB)"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.scoreTableWidthMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="scoreTableWidth (MB)"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.tableLessonFontMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="tableLessonFont (MB)"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.totalScoreFontSizeMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="totalScoreFontSize (MB)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="background-color: #ffebee">
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.signatureXMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="signatureX (MB)"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.signatureYMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="signatureY (MB)"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.signatureFontMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="signatureFont (MB)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="background-color: #e3f2fd">
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText1"
                @input="_updateMarginPage2"
                label="signatureText1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText1EN"
                @input="_updateMarginPage2"
                label="signatureText1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText1MB"
                @input="_updateMarginPage2"
                label="signatureText1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName1"
                @input="_updateMarginPage2"
                label="signatureName1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName1EN"
                @input="_updateMarginPage2"
                label="signatureName1EN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName1MB"
                @input="_updateMarginPage2"
                label="signatureName1MB"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row style="background-color: #e3f2fd">
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText2"
                @input="_updateMarginPage2"
                label="signatureText2"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText2EN"
                @input="_updateMarginPage2"
                label="signatureText2EN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText2MB"
                @input="_updateMarginPage2"
                label="signatureText2MB"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName2"
                @input="_updateMarginPage2"
                label="signatureName2"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName2EN"
                @input="_updateMarginPage2"
                label="signatureName2EN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName2MB"
                @input="_updateMarginPage2"
                label="signatureName2MB"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.diplomPreText"
                @input="_updateMarginPage2"
                label="diplomPreText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.diplomPreTextEN"
                @input="_updateMarginPage2"
                label="diplomPreText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.diplomPreTextMB"
                @input="_updateMarginPage2"
                label="diplomPreText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.diplomPreTextXMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="diplomPreTextX"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.diplomPreTextYMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="diplomPreTextY"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.diplomTopicFontSizeMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="diplomTopicFontSize (MB)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.bottomText"
                @input="_updateMarginPage2"
                label="bottomText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.bottomTextEN"
                @input="_updateMarginPage2"
                label="bottomTextEN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.bottomTextMB"
                @input="_updateMarginPage2"
                label="bottomTextMB"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.bottomTextXMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="bottomTextX (MB)"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.bottomTextYMB"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="bottomTextY (MB)"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PrintComponent from "./PrintComponent.vue";
import Page1EN from "./Page1EN.vue";
import Page1MB from "./Page1MB.vue";
import DiplomPage2 from "./DiplomPage2.vue";
import Page2 from "./Page2.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      selectedLanguageType: null,
      ui_setting: {},
      ui_setting_page2: {},
      ui_setting_page1_eng: {},
      ui_setting_page1_mb: { texts: [], fullscreen: true },
    };
  },
  computed: {
    page2Items() {
      return this.ui_setting_page1_eng.texts;
    },
    page2ItemsMB() {
      return this.ui_setting_page1_mb.texts;
    },
  },
  components: {
    PrintComponent,
    DiplomPage2,
    Page2,
    Page1EN,
    Page1MB,
    ...mapState(["userProfile", "currentUser", "xxschoolPath"]),
  },
  created() {
    this.selectedLanguageType = { name: "1. Монгол xэл", languageType: 3 };
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui")
      .onSnapshot((doc) => {
        this.ui_setting = doc.data();
        this.ui_setting.ref = doc.ref;
        this.ui_setting.id = doc.id;
      });
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page2")
      .onSnapshot((doc) => {
        this.ui_setting_page2 = doc.data();
        this.ui_setting_page2.ref = doc.ref;
        this.ui_setting_page2.id = doc.id;
      });

    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page1-mb")
      .onSnapshot((doc) => {
        this.ui_setting_page1_mb = doc.data();
        this.ui_setting_page1_mb.ref = doc.ref;
        this.ui_setting_page1_mb.id = doc.id;
        console.log(this.ui_setting_page1_mb);
      });

    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page1-en")
      .onSnapshot((doc) => {
        this.ui_setting_page1_eng = doc.data();
        this.ui_setting_page1_eng.ref = doc.ref;
        this.ui_setting_page1_eng.id = doc.id;
        console.log(this.ui_setting_page1_eng);
      });
  },

  props: {
    student: {
      required: true,
      type: Object,
    },
  },

  methods: {
    _deleteTextItem(uisett, textItemIndex) {
      uisett.texts.splice(textItemIndex, 1);
      uisett.ref.update(uisett).then(() => {
        console.log("delete");
      });
    },
    _addNewField(uisett) {
      uisett.texts.push({ text: "NEW_TEXT", x: 10, y: 10, fontSize: 11 });
      uisett.ref.update(uisett).then(console.log("done"));
    },

    _getTranslateString(keyword) {
      if (keyword == "firstName" && this.selectedLanguageType.languageType == 1)
        return this.student.firstName;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.student.firstNameEN;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.student.firstNameMB;
    },
    _updateFullScreen() {
      this.ui_setting.fullscreen = !this.ui_setting.fullscreen;
      this.ui_setting.ref.update(this.ui_setting);
    },

    _updateFullScreenPage2() {
      this.ui_setting_page2.fullscreenPage2 =
        !this.ui_setting_page2.fullscreenPage2;
      this.ui_setting_page2.ref.update(this.ui_setting_page2);
    },
    _updateMarginPage2() {
      this.ui_setting_page2.ref.update(this.ui_setting_page2);
    },
    _updateMargin() {
      this.ui_setting.ref.update(this.ui_setting);
    },
    _updatePage1EN() {
      console.log(this.page2Items, this.ui_setting_page1_eng.ref.path);
      this.ui_setting_page1_eng.ref.update({ texts: this.page2Items });
    },
    _updatePage1MB() {
      console.log(this.page2ItemsMB, this.ui_setting_page1_mb.ref.path);
      this.ui_setting_page1_mb.ref.update({ texts: this.page2ItemsMB });
    },
    _updatePage1ENFullScreen(setting) {
      setting.fullscreen = !setting.fullscreen;
      setting.ref.update(setting);
    },
    _print(idd) {
      // this.$htmlToPaper("printMe");

      const printableElement = document.getElementById(idd);
      if (printableElement) {
        const printWindow = window.open();
        printWindow.document.write(
          "<html><head><title>Print</title> <style>@media print {@page {size: landscape;}}</style></head><body>"
        );
        printWindow.document.write(printableElement.innerHTML);
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
      }
    },
    _print2(idd) {
      const printableElement = document.getElementById(idd);
      var printWindow = window.open();
      printWindow.document.write("<html><head><title>Table Contents</title>");

      //Print the Table CSS.
      var table_style = document.getElementById("table_style").innerHTML;
      printWindow.document.write('<style type = "text/css">');
      printWindow.document.write(table_style);
      printWindow.document.write("</style>");
      printWindow.document.write("</head>");

      //Print the DIV contents i.e. the HTML Table.
      printWindow.document.write("<body>");
      printWindow.document.write(printableElement);
      printWindow.document.write("</body>");
      printWindow.document.write("</html>");
      printWindow.document.close();
      printWindow.print();
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
  }
}
</style>

